module.exports = __webpack_public_path__ + "static/media/grip.ee188f4b.gif";